import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UiSuggestIntl } from '@uipath/angular/components/ui-suggest';

import { takeUntil } from 'rxjs/operators';

@Injectable()
export class UiAutocompleteIntl extends UiSuggestIntl {
    constructor(
        protected _translateService: TranslateService,
    ) {
        super();

        _translateService
            .stream([
                'select_no_results_text',
                'item_suggestion_is_loading',
                'suggest_custom_value',
                'clear_selection',
            ])
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(this._updateLabels);
    }

    public currentItemLabel = (text: string, itemNo: number, itemCount: number) =>
        this._translateService.instant('current_item_out_of', { text, itemNo, itemCount })

    private _updateLabels = ({
        item_suggestion_is_loading,
        select_no_results_text,
        suggest_custom_value,
        clear_selection,
    }: Record<string, string>) => {
        this.noResultsLabel = select_no_results_text;
        this.loadingLabel = item_suggestion_is_loading;
        this.customValueLiveLabel = suggest_custom_value;
        this.clearSelectionLabel = clear_selection;
    }
}
